define("calendar/components/calendar/onboarding/wizards/schedule-first-post-successful/body", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <h2 class="tOB--wizard__title">
    {{html-safe (t (concat "onboarding.successfully_scheduled." @title) platform=@profileType)}}
  </h2>
  <p class="tOB--wizard__subtitle">
    {{html-safe (t (concat "onboarding.successfully_scheduled." @text) platform=@profileType)}}
  </p>
  */
  {
    "id": "YC1rR5Gv",
    "block": "[[[10,\"h2\"],[14,0,\"tOB--wizard__title\"],[12],[1,\"\\n  \"],[1,[28,[35,0],[[28,[37,1],[[28,[37,2],[\"onboarding.successfully_scheduled.\",[30,1]],null]],[[\"platform\"],[[30,2]]]]],null]],[1,\"\\n\"],[13],[1,\"\\n\"],[10,2],[14,0,\"tOB--wizard__subtitle\"],[12],[1,\"\\n  \"],[1,[28,[35,0],[[28,[37,1],[[28,[37,2],[\"onboarding.successfully_scheduled.\",[30,3]],null]],[[\"platform\"],[[30,2]]]]],null]],[1,\"\\n\"],[13]],[\"@title\",\"@profileType\",\"@text\"],false,[\"html-safe\",\"t\",\"concat\"]]",
    "moduleName": "calendar/components/calendar/onboarding/wizards/schedule-first-post-successful/body.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});